import { createRootRoute, createRoute, createRouter } from '@tanstack/react-router';
import { Layout } from './components/Layout';
import { AgentPage } from './pages/agent/AgentPage';
import { Agents } from './pages/Agents';
import { Models } from './pages/Models';
import { Requests } from './pages/Requests';
import { Settings } from './pages/Settings';
import { Snippets } from './pages/Snippets';
import { TracePage } from './pages/TracePage';

const root = createRootRoute({ component: Layout });
const agents = createRoute({ getParentRoute: () => root, path: '/', component: Agents });
const agent = createRoute({
  getParentRoute: () => root,
  path: '/agents/$agentId',
  // ?replay=<traceId> opens the playground with that request's inputs.
  validateSearch: (s: Record<string, unknown>): { replay?: string } => (typeof s.replay === 'string' && s.replay ? { replay: s.replay } : {}),
  component: () => <AgentPage agentId={agent.useParams().agentId} replayTraceId={agent.useSearch().replay} />,
});
const requests = createRoute({ getParentRoute: () => root, path: '/requests', component: Requests });
const trace = createRoute({ getParentRoute: () => root, path: '/requests/$traceId', component: () => <TracePage traceId={trace.useParams().traceId} /> });
const models = createRoute({ getParentRoute: () => root, path: '/models', component: Models });
const snippets = createRoute({ getParentRoute: () => root, path: '/snippets', component: Snippets });
const settings = createRoute({ getParentRoute: () => root, path: '/settings', component: Settings });

export const router = createRouter({ routeTree: root.addChildren([agents, agent, requests, trace, models, snippets, settings]) });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
